module.exports = __webpack_public_path__ + "img/star-fill.d162db33.svg";